import React, { useEffect, useState } from "react";
import "./Admin.css";
import { FaCircleNotch } from "react-icons/fa6";
import { uploadData } from "../../services/api";

function Admin() {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [codeExample, setCodeExample] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [categorie, setCategorie] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [adminId, setAdminId] = useState("");
  const [online, setOnline] = useState(navigator.onLine);
  const [uploading, setUploading] = useState(false);
  const [errors, setErrors] = useState({
    question: "",
    answer: "",
    codeExample: "",
    difficulty: "",
    categorie: "",
    selectedLanguage: "",
    adminId: "",
    general: ""
  });

  const categorySuggestions = ["programming", "history", "science"];
  const difficultySuggestions = ["easy", "medium", "hard"];

  const [categoryIndex, setCategoryIndex] = useState(0);
  const [difficultyIndex, setDifficultyIndex] = useState(0);

  useEffect(() => {
    const handleOnlineStatus = () => {
      setOnline(navigator.onLine);
    };

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOnlineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOnlineStatus);
    };
  }, []);

  const handleSubmit = async(e) => {
    e.preventDefault();
    if (!question.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        question: "Question is required",
      }));
      return;
    }
    if (!answer.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        answer: "Answer is required",
      }));
      return;
    }
    if (!codeExample.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        codeExample: "Code Example is required",
      }));
      return;
    }
    if (!difficulty.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        difficulty: "Difficulty is required",
      }));
      return;
    }
    if (!categorie.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        categorie: "Categorie is required",
      }));
      return;
    }
    if (!selectedLanguage.trim() || selectedLanguage.trim() === "Select Language") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        selectedLanguage: "Select a language",
      }));
      return;
    }
    if(!adminId.trim()){
      setErrors((prevErrors) => ({
        ...prevErrors, 
        adminId: "Admin Id is required"
      }))
      return
    }

    try {
      
      setUploading(true);
  
      const response = await uploadData({
        question,
        answer,
        codeExample,
        difficulty,
        categorie,
        selectedLanguage,
        adminId,
      })
      setUploading(false)
      setErrors((prevErrors) => ({
        ...prevErrors, general: response.message
      }))
      console.log("out response : ", response)
  
  
    } catch (error) { 
        setUploading(false)
        if (error.response && error.response.status === 401) {
          
          setErrors((prevErrors) => ({
            ...prevErrors, general: error.response.data.error
          }));
        }else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            general: error?.message || "An error occurred",
          }));
        }
        console.log("error : ", error)
    } finally{
      setUploading(false)
    }

    setQuestion("");
    setAnswer("");
    setCodeExample("");
    setDifficulty("");
    setCategorie("");
    setSelectedLanguage("");
    setAdminId("")
  };

  
  
  const handleCategorieSuggestion = () => {
    setCategorie(categorySuggestions[categoryIndex]);
    setCategoryIndex((categoryIndex + 1) % categorySuggestions.length);
  };
  
  const handleDifficultySuggestion = () => {
    setDifficulty(difficultySuggestions[difficultyIndex]);
    setDifficultyIndex((difficultyIndex + 1) % difficultySuggestions.length);
  };
  
  const handleLanguageChange = (e) => {
    setSelectedLanguage(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedLanguage: '',
    }));
  };
  const handleQuestionChange = (e) => {
    setQuestion(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      question: "",
    }));
  };
  const handleAnswerChange = (e) => {
    setAnswer(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      answer: "",
    }));
  };
  const handleCodeExampleChange = (e) => {
    setCodeExample(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      codeExample: "",
    }));
  };
  const handleDifficultyChange = (e) => {
    setDifficulty(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      difficulty: "",
    }));
  };
  const handleCategorieChange = (e) => {
    setCategorie(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      categorie: "",
    }));
  };

  const handleAdminIdChange = (e) => {
    setAdminId(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      adminId: "",
      general: ""
    }));
  }

  return (
    <div className="adminContainer bg-blue-200 text-gray-950  flex flex-col">
      <form
        onSubmit={handleSubmit}
        className="flex flex-col w-[50%] m-auto relative"
      >
        <p className="securityBadge">axi🔐</p>

        <span className="onlineStatus">
          <p
            className={`onlineDot ${online ? "bg-yellow-400" : "bg-red-600"}`}
          ></p>
          {online ? "online" : "offline"}
        </span>

        <label htmlFor="question">Question</label>
        <input
          type="text"
          name="question"
          onChange={handleQuestionChange}
          value={question}
          id="question"
        />
        {errors && <span className="error-message">{errors.question}</span>}

        <label htmlFor="answer">Answer</label>
        <textarea
          type="text"
          cols={1}
          rows={1}
          name="answer"
          value={answer}
          onChange={handleAnswerChange}
          id="answer"
        />
        {errors && <span className="error-message">{errors.answer}</span>}

        <section className="flex w-full justify-between">
          <label htmlFor="codeExample">Code Example</label>
          <select
            name="language"
            id="language"
            value={selectedLanguage}
            onChange={handleLanguageChange}
            className={errors.selectedLanguage ? "bg-red-700" : ""}
          >
            <option value="">Select Language</option>
            <option value="javascript">JavaScript</option>
            <option value="html">Html</option>
            <option value="css">CSS</option>
            <option value="java">Java</option>
            <option value="python">Python</option>
            <option value="node js">Node JS</option>

            <option value="c++">C++</option>
            <option value="c">C</option>
            <option value="c#">C#</option>
            <option value="ruby">Ruby</option>
            <option value="php">PHP</option>
            <option value="rust">Rust</option>
            <option value="swift">Swift</option>
            <option value="kotlin">Kotlin</option>
            <option value="scala">Scala</option>
            <option value="go">Go</option>
            <option value="r">R</option>
            <option value="dart">Dart</option>
            <option value="racket">Racket</option>
            <option value="haskell">Haskell</option>
            <option value="f#">F#</option>
          </select>
        </section>
        <textarea
          type="text"
          name="codeExample"
          value={codeExample}
          onChange={handleCodeExampleChange}
          id="codeExample"
        />
        {errors && <span className="error-message">{errors.codeExample}</span>}
        <label htmlFor="difficultySuggestion">
          Click for Difficulty Suggestion
        </label>
        <input
          type="text"
          name="difficultySuggestion"
          id="difficultySuggestion"
          value={difficulty}
          onChange={handleDifficultyChange}
          onClick={handleDifficultySuggestion}
        />
        {errors && <span className="error-message">{errors.difficulty}</span>}

        <label htmlFor="categorie">Click for Category</label>
        <input
          type="text"
          name="categorie"
          id="categorie"
          onChange={handleCategorieChange}
          value={categorie}
          onClick={handleCategorieSuggestion}
        />

        {errors && <span className="error-message">{errors.categorie}</span>}
          {errors && <span className="error-message">{errors.general}</span>}
        <section className="w-full flex flex-row">
          <input type="text" onChange={handleAdminIdChange} value={adminId} className={`${errors.adminId ? 'border border-red-500' : ''}`}  placeholder="admin id" />
          <button 
          disabled={uploading}
           className={`relative bg-gray-100 ${uploading && 'uploadingAnimation'}`}  type="submit">
            <span></span>
            {uploading ? <FaCircleNotch className="loadingCircle"/> : "Submit"}
          </button>
        </section>
      </form>
    </div>
  );
}

export default Admin;
